import { getLandingPath } from '../../routing/route';

export const renderNotFoundView = (container: HTMLElement, onNavigate: (path: string) => void): void => {
  const landingPath = getLandingPath();

  container.innerHTML = `
    <div class="not-found-page">
      <div class="not-found-card">
        <p class="not-found-code">404</p>
        <h1 class="not-found-title">ページが見つかりません</h1>
        <p class="not-found-text">
          お探しのページは存在しないか、移動または削除された可能性があります。
        </p>
        <div class="not-found-actions">
          <a href="${landingPath}" class="landing-cta-button" data-nav="${landingPath}">ゲーム紹介へ戻る</a>
        </div>
      </div>
    </div>
  `;

  const links = container.querySelectorAll<HTMLAnchorElement>('a[data-nav]');
  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const targetPath = link.getAttribute('data-nav') ?? landingPath;
      onNavigate(targetPath);
    });
  });
};
